/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FuelSurchargeValuesInput
 */
export interface FuelSurchargeValuesInput {
  /**
   *
   * @type {string}
   * @memberof FuelSurchargeValuesInput
   */
  fuelSurchargeValueId?: string | null;
  /**
   *
   * @type {string}
   * @memberof FuelSurchargeValuesInput
   */
  carrierIdentifier: string;
  /**
   *
   * @type {string}
   * @memberof FuelSurchargeValuesInput
   */
  fuelSurchargeIdentifier: string;
  /**
   *
   * @type {number}
   * @memberof FuelSurchargeValuesInput
   */
  value: number;
  /**
   *
   * @type {string}
   * @memberof FuelSurchargeValuesInput
   */
  notes?: string | null;
  /**
   *
   * @type {string}
   * @memberof FuelSurchargeValuesInput
   */
  editReason?: string | null;
}

/**
 * Check if a given object implements the FuelSurchargeValuesInput interface.
 */
export function instanceOfFuelSurchargeValuesInput(
  value: object,
): value is FuelSurchargeValuesInput {
  if (
    !("carrierIdentifier" in value) ||
    value["carrierIdentifier"] === undefined
  )
    return false;
  if (
    !("fuelSurchargeIdentifier" in value) ||
    value["fuelSurchargeIdentifier"] === undefined
  )
    return false;
  if (!("value" in value) || value["value"] === undefined) return false;
  return true;
}

export function FuelSurchargeValuesInputFromJSON(
  json: any,
): FuelSurchargeValuesInput {
  return FuelSurchargeValuesInputFromJSONTyped(json, false);
}

export function FuelSurchargeValuesInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): FuelSurchargeValuesInput {
  if (json == null) {
    return json;
  }
  return {
    fuelSurchargeValueId:
      json["fuelSurchargeValueId"] == null
        ? undefined
        : json["fuelSurchargeValueId"],
    carrierIdentifier: json["carrierIdentifier"],
    fuelSurchargeIdentifier: json["fuelSurchargeIdentifier"],
    value: json["value"],
    notes: json["notes"] == null ? undefined : json["notes"],
    editReason: json["editReason"] == null ? undefined : json["editReason"],
  };
}

export function FuelSurchargeValuesInputToJSON(
  json: any,
): FuelSurchargeValuesInput {
  return FuelSurchargeValuesInputToJSONTyped(json, false);
}

export function FuelSurchargeValuesInputToJSONTyped(
  value?: FuelSurchargeValuesInput | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    fuelSurchargeValueId: value["fuelSurchargeValueId"],
    carrierIdentifier: value["carrierIdentifier"],
    fuelSurchargeIdentifier: value["fuelSurchargeIdentifier"],
    value: value["value"],
    notes: value["notes"],
    editReason: value["editReason"],
  };
}
